<template>
  <div>
    <b-modal @cancel="hideModal" no-close-on-backdrop ref="SettingsModal" size="lg" title="Settings" centered
      hide-footer>
      <b-row v-if="loading" class="d-flex justify-content-center">
        <b-spinner style="width: 3rem; height: 3rem;" variant="primary" label="Spinning"></b-spinner>
      </b-row>
      <b-row>
        <b-col cols="3">
          <label>Shop</label>
        </b-col>
        <b-col cols="9">
          <b-form-select @input="refreshProducts" v-model="selected_shop" :options="shopList"></b-form-select>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import Shops from "@/mixins/Shops";
import SiteSettings from "@/mixins/SiteSettings";
export default {
  name: "Setting",
  mixins: [Shops, SiteSettings],
  data: () => ({
    loading: false,
    // shops: ["aa", "ss"],
  }),
  computed: {
    selected_shop: {
      get() {
        return this.selected;
      },
      set(data) {
        this.$store.dispatch("shops/fetchShopInfo", data);
      },
    },
    shopList: function () {
      if (this.shops.length) {
        return this.shops.map((item) => ({
          text: item.name,
          value: item,
        }));
      }
      return [];
    },
  },
  methods: {
    refreshProducts() {
      this.$store.dispatch("product/fetchProducts");
    },
    showModal() {
      this.$refs["SettingsModal"].show();
    },
    hideModal() {
      this.$refs["SettingsModal"].hide();
    },
  },
};
</script>
